import drawOuterRingPart from "./drawOuterRingPart";
import selectColor from "./selectColor";

const drawOuterRings = (
    x, y, orr, orir, partSizes, scales,
    onePartSize, rotation, offset, colors
) => {
    const elements = [];
    let partSelector = 0;
    let angle = 0;
    while (angle < Math.PI * 2) {

        // default color for outer ring
        let outerRingColor;

        switch (scales[partSelector].score) {
            case 1:
            case 2:
                outerRingColor = colors.belowAverage;
                break;
            case 3:
                outerRingColor = colors.average;
                break;
            case 4:
            case 5:
                outerRingColor = colors.aboveAverage;
                break;
            default:
                break;
        }

        const partSpan = partSizes[partSelector];
        const partSize = onePartSize * partSpan;
        angle += partSize;
        const a = angle - (partSize / 2) + rotation;
        const o = offset / partSpan;

        // in the end it was decided not to include the pieShape. but since it is a nice function
        // and future requirements may change, I believe it is better to leave the function available
        // const partDepth = partDepths[partSelector];
        // const r = ir + (mr / rings) * partDepth;
        // drawPieShape(svg, x, y, a, partSize, r, ir, o, selectColor(colors, partDepth));
        elements.push(drawOuterRingPart(
            x, y, a, partSize, orr, orir, o, outerRingColor
        ));
        partSelector++;
    }
    return elements;
}

export default drawOuterRings;
